import(/* webpackMode: "eager" */ "/Users/sdmswork/Documents/Fydo/backend/Fydo-Event-Website/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/sdmswork/Documents/Fydo/backend/Fydo-Event-Website/src/app/category/[slug]/components/categoryBanner/categoryBanner.component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/sdmswork/Documents/Fydo/backend/Fydo-Event-Website/src/app/category/[slug]/components/categoryList/categoryList.component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Label"] */ "/Users/sdmswork/Documents/Fydo/backend/Fydo-Event-Website/src/components/ui/label.tsx");
;
import(/* webpackMode: "eager" */ "/Users/sdmswork/Documents/Fydo/backend/Fydo-Event-Website/src/images/appleStore.png");
;
import(/* webpackMode: "eager" */ "/Users/sdmswork/Documents/Fydo/backend/Fydo-Event-Website/src/images/googlePlay.png");
;
import(/* webpackMode: "eager" */ "/Users/sdmswork/Documents/Fydo/backend/Fydo-Event-Website/src/images/logo.png");
;
import(/* webpackMode: "eager" */ "/Users/sdmswork/Documents/Fydo/backend/Fydo-Event-Website/src/images/logoWhite.png");
